import type { EventName } from "@lit/react";
import { RichTextEditor as RichTextEditorElement, type RichTextEditorEventMap as _RichTextEditorEventMap, } from "@vaadin/rich-text-editor/vaadin-rich-text-editor.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { RichTextEditorElement, };
export type RichTextEditorEventMap = Readonly<{
    onChange: EventName<_RichTextEditorEventMap["change"]>;
    onHtmlValueChanged: EventName<_RichTextEditorEventMap["html-value-changed"]>;
    onValueChanged: EventName<_RichTextEditorEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onHtmlValueChanged: "html-value-changed", onValueChanged: "value-changed" } as RichTextEditorEventMap;
export type RichTextEditorProps = WebComponentProps<RichTextEditorElement, RichTextEditorEventMap>;
export const RichTextEditor = createComponent({
    elementClass: RichTextEditorElement, events, react: React, tagName: "vaadin-rich-text-editor"
});
